"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgHeartSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M10.876 2.863l1.118.955 1.145-.969.148-.142a6.348 6.348 0 018.847.18c2.48 2.504 2.488 6.554.025 9.07l-8.227 10.116c-1.011 1.132-2.672 1.177-3.754.112l-.132-.14-8.21-10.094-.146-.154c-2.311-2.526-2.252-6.46.178-8.91a6.349 6.349 0 019.008-.024z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgHeartSolid;
exports.default = _default;